import { AuthenticationImpl } from "features/login/data/AuthenticationImpl";
import { LoginViewModel } from "features/login/presentation/viewModel/LoginViewModel";
import { IAuthenticationRepository } from "../domain/repositories/IAuthenticationRepository";
import { AuthenticationUseCase } from "../domain/useCases/AuthenticationUseCase";
import { InjectionBinding, InjectionModule } from "app/di/DependencyInjections";

export class AuthenticationInjection extends InjectionModule {
  private static readonly authenticationRepositoryToken = Symbol(
    "IAuthenticationRepository",
  );
  private static readonly authenticationUseCaseToken = Symbol(
    "AuthenticationUseCase",
  );
  private static readonly loginViewModelToken = Symbol("LoginViewModel");

  protected static override bindings: InjectionBinding[] = [
    {
      scope: "otherRepo",
      token: this.authenticationRepositoryToken,
      useClass: AuthenticationImpl,
    },
    {
      scope: "otherRepo",
      token: this.authenticationUseCaseToken,
      useClass: AuthenticationUseCase,
    },
    {
      scope: "viewModel",
      token: this.loginViewModelToken,
      useClass: LoginViewModel,
    },
  ];

  static getAuthenticationRepo() {
    return this.resolve<IAuthenticationRepository>(
      this.authenticationRepositoryToken,
    );
  }

  static getAuthenticationUseCase() {
    return this.resolve<AuthenticationUseCase>(this.authenticationUseCaseToken);
  }
}
